import styled from '@emotion/styled';

import glyphStyles from '../../../components/common/Glyph.module.css';
import { su } from '../../../theme/functions/su';
import { motion } from '../../../theme/motion';
import { theme } from '../../../theme/theme';

import { Glyph } from '../../../components/common/Glyph';

export function ZoneNavigationDraftItem({
  item,
  icon,
  draftZone,
  onDraftZoneBlur,
  onDraftZoneSave,
  EditNameTextField,
}) {
  return (
    <S.Zone key={item.id} level={item.level}>
      <S.ZoneIconWrapper>
        <Glyph source={icon(null)} size={theme.icon.size_default} color={theme.color.icon_dark} />
      </S.ZoneIconWrapper>

      {draftZone.id === 'create' ? (
        <EditNameTextField
          defaultValue=""
          onBlur={(event) => {
            if (event.currentTarget.value.length === 0) return onDraftZoneBlur();

            onDraftZoneSave({
              id: item.id,
              parentId: draftZone.parentId,
              value: event.currentTarget.value,
            });
          }}
          onKeyUp={(event) => {
            switch (event.key) {
              case 'Enter':
                if (event.currentTarget.value.length === 0) return;

                onDraftZoneSave({
                  id: item.id,
                  parentId: draftZone.parentId,
                  value: event.currentTarget.value,
                });
                break;
              case 'Escape':
                onDraftZoneBlur();
                break;
              default:
                break;
            }
          }}
        />
      ) : (
        <S.ZoneLabel isSelected={false}>{draftZone.name}</S.ZoneLabel>
      )}
    </S.Zone>
  );
}

const S = {};

S.ZoneLabel = styled.span``;

S.Zone = styled.div`
  display: flex;
  position: relative;
  z-index: calc(${theme.zIndex.nav} + 1);
  align-items: stretch;
  margin: 1px ${su(1)};
  border-radius: ${theme.borderRadius.default};
  padding-inline-start: ${({ level }) => `${level * 20 + 10}px`};
  padding-inline-end: ${su(1)};
  outline: 0;
  cursor: pointer;
  user-select: none;
  border: 1px solid transparent;
  transition: all ${motion.duration.fast} ${motion.curve.fast_in};

  ${S.ZoneLabel} {
    display: inline-block;
    flex: 1 1 auto;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    line-height: ${su(2)};
    padding: ${su(1)};
  }
`;

S.ZoneIconWrapper = styled.div`
  flex: 0 0 auto;
  display: flex;
  align-items: center;

  .${glyphStyles.root} {
    color: ${theme.color.icon_dark};
    transition: color ${motion.duration.fast} ${motion.curve.fast_in};
  }
`;
